import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home } from "lucide-react";

export default function UtilityBar() {
    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null);
    const { pathname } = useLocation();

    useEffect(() => setOpen(false), [pathname]);

    useEffect(() => {
        const onDocClick = (e: MouseEvent) => {
            if (!menuRef.current?.contains(e.target as Node)) setOpen(false);
        };
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") setOpen(false);
        };
        document.addEventListener("click", onDocClick);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("click", onDocClick);
            document.removeEventListener("keydown", onKey);
        };
    }, []);

    return (
        <div className="bg-white border-b text-sm z-[100] relative">
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-2 flex flex-wrap items-center justify-between gap-2">

                {/* ✅ Left: Return to Main Site link */}
                <div className="flex items-center gap-2">
                    <Link
                        to="/"
                        className="flex items-center gap-1.5 font-semibold text-indigo-700 hover:text-indigo-800 transition-colors !text-indigo-700"
                        title="Return to SecureID Technologies Home"
                        style={{ color: "#3730a3" }} // 👈 ensures text always indigo
                    >
                        <Home size={16} className="text-indigo-700 shrink-0" />
                        <span
                            className="hidden sm:inline"
                            style={{ color: "#3730a3" }}
                        >
                            Return to Main Site
                        </span>
                        <span
                            className="sm:hidden"
                            style={{ color: "#3730a3" }}
                        >
                            Home
                        </span>
                    </Link>
                </div>

                {/* ✅ Right: Utility links */}
                {/*<div className="flex items-center gap-3 text-gray-700 flex-wrap">*/}
                {/*    <Link to="/login" className="hover:text-indigo-600">*/}
                {/*        Exams Admin Login*/}
                {/*    </Link>*/}
                {/*    <span className="text-gray-300 select-none">|</span>*/}
                {/*    <Link to="/candidate/login" className="hover:text-indigo-600">*/}
                {/*        Exam Taker Login*/}
                {/*    </Link>*/}
                {/*    <span className="text-gray-300 select-none">|</span>*/}
                {/*    <Link to="/support" className="hover:text-indigo-600">*/}
                {/*        Customer Support*/}
                {/*    </Link>*/}
                {/*    <span className="text-gray-300 select-none">|</span>*/}
                {/*    <Link to="/support/contact" className="hover:text-indigo-600">*/}
                {/*        Contact Support*/}
                {/*    </Link>*/}
                {/*</div>*/}
            </div>
        </div>
    );
}